import {useEffect, useRef, useState} from "react";

import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";
import {IBinaryExperiment, ITrackExperimentExposureOptions} from "./use_binary_experiment";
import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";
import {useUnlockChoiceExperiment} from "./use_unlock_choice_experiment";

export interface IRegistrationWizardGateVariants {
    isWizard: boolean;
    isChoice: boolean;
}

export interface IRegistrationWizardGateDecision extends IRegistrationWizardGateVariants {
    /** Settles once the exposures of the decided experiments are sent, null when none was sent */
    exposureTracking: Promise<void> | null;
}

interface IUseRegistrationWizardGateDecisionParams {
    /** The flow depends on the registration wizard experiment, for its authentication step or for the scope of the unlock choice */
    readsWizard: boolean;
    /** Whether the unlock choice experiment decides the flow, given the wizard variant decided so far */
    isChoiceInScope: (isWizard: boolean) => boolean;
    getExposureOptions?: (variants: IRegistrationWizardGateVariants) => ITrackExperimentExposureOptions;
    onDecide: (decision: IRegistrationWizardGateDecision) => void;
}

const isDecidedTreatment = (isRead: boolean, experiment: IBinaryExperiment) => isRead && experiment.isResolved && experiment.isTreatment;

/**
 * Waits up to the timeout for every experiment the flow depends on. An experiment still unresolved at the timeout counts as
 * its control, and only the resolved ones in scope report the exposure.
 */
export const useRegistrationWizardGateDecision = ({readsWizard, isChoiceInScope, getExposureOptions, onDecide}: IUseRegistrationWizardGateDecisionParams) => {
    const wizardExperiment = useRegistrationWizardExperiment({isEnabled: readsWizard});
    const isWizard = isDecidedTreatment(readsWizard, wizardExperiment);
    const readsChoice = isChoiceInScope(isWizard);
    const choiceExperiment = useUnlockChoiceExperiment({isEnabled: readsChoice});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);
    const isWizardSettled = !readsWizard || wizardExperiment.isResolved;
    const isChoiceSettled = !readsChoice || choiceExperiment.isResolved;

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current || (!(isWizardSettled && isChoiceSettled) && !hasTimedOut)) {
            return;
        }

        hasDecidedRef.current = true;

        const variants = {isWizard, isChoice: isDecidedTreatment(readsChoice, choiceExperiment)};
        const exposureOptions = getExposureOptions?.(variants);
        const exposures = [
            readsWizard && wizardExperiment.isResolved ? wizardExperiment.trackExposure(exposureOptions) : null,
            readsChoice && choiceExperiment.isResolved ? choiceExperiment.trackExposure(exposureOptions) : null
        ].filter((exposure) => exposure !== null);

        onDecide({...variants, exposureTracking: exposures.length > 0 ? Promise.all(exposures).then(() => undefined) : null});
    }, [isWizardSettled, isChoiceSettled, isWizard, choiceExperiment.isTreatment, hasTimedOut]);
};
import {useEffect, useRef, useState} from "react";

import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "../constants/unlock_choice_timeouts";
import {IBinaryExperiment, ITrackExperimentExposureOptions} from "./use_binary_experiment";
import {useRegistrationWizardExperiment} from "./use_registration_wizard_experiment";
import {useUnlockChoiceExperiment} from "./use_unlock_choice_experiment";

export interface IRegistrationWizardGateVariants {
    isWizard: boolean;
    isChoice: boolean;
}

export interface IRegistrationWizardGateDecision extends IRegistrationWizardGateVariants {
    /** Settles once the exposures of the decided experiments are sent, null when none was sent */
    exposureTracking: Promise<void> | null;
}

interface IUseRegistrationWizardGateDecisionParams {
    /** The flow depends on the registration wizard experiment, for its authentication step or for the scope of the unlock choice */
    readsWizard: boolean;
    /** Whether the unlock choice experiment decides the flow, given the wizard variant decided so far */
    isChoiceInScope: (isWizard: boolean) => boolean;
    getExposureOptions?: (variants: IRegistrationWizardGateVariants) => ITrackExperimentExposureOptions;
    onDecide: (decision: IRegistrationWizardGateDecision) => void;
}

const isDecidedTreatment = (isRead: boolean, experiment: IBinaryExperiment) => isRead && experiment.isResolved && experiment.isTreatment;

/**
 * Waits up to the timeout for every experiment the flow depends on. An experiment still unresolved at the timeout counts as
 * its control, and only the resolved ones in scope report the exposure.
 */
export const useRegistrationWizardGateDecision = ({readsWizard, isChoiceInScope, getExposureOptions, onDecide}: IUseRegistrationWizardGateDecisionParams) => {
    const wizardExperiment = useRegistrationWizardExperiment({isEnabled: readsWizard});
    const isWizard = isDecidedTreatment(readsWizard, wizardExperiment);
    const readsChoice = isChoiceInScope(isWizard);
    const choiceExperiment = useUnlockChoiceExperiment({isEnabled: readsChoice});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);
    const isWizardSettled = !readsWizard || wizardExperiment.isResolved;
    const isChoiceSettled = !readsChoice || choiceExperiment.isResolved;

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current || (!(isWizardSettled && isChoiceSettled) && !hasTimedOut)) {
            return;
        }

        hasDecidedRef.current = true;

        const variants = {isWizard, isChoice: isDecidedTreatment(readsChoice, choiceExperiment)};
        const exposureOptions = getExposureOptions?.(variants);
        const exposures = [
            readsWizard && wizardExperiment.isResolved ? wizardExperiment.trackExposure(exposureOptions) : null,
            readsChoice && choiceExperiment.isResolved ? choiceExperiment.trackExposure(exposureOptions) : null
        ].filter((exposure) => exposure !== null);

        onDecide({...variants, exposureTracking: exposures.length > 0 ? Promise.all(exposures).then(() => undefined) : null});
    }, [isWizardSettled, isChoiceSettled, isWizard, choiceExperiment.isTreatment, hasTimedOut]);
};
